import { create } from 'zustand';

/**
 * useStreetcarStore — progress state for the NAV-02 scripted streetcar ride.
 *
 * Plan 05-01 Task 1 contract. The real END_OF_LINE / ARRIVAL_DONE dispatch
 * lives in StreetcarRig / ArrivalCinematic (via useNavSend from NavContext),
 * NOT in this store — keeping the store a pure data slice and the machine
 * the single source of truth for transitions.
 *
 * `onEndOfLine` / `onArrivalDone` are no-op placeholders here so consumers
 * have a stable shape. Plan 05-02 may later swap these in for direct
 * callback wiring if the arrivalCinematic rig needs store-level coordination.
 *
 * Shape:
 *   - progress: 0..1 — current spline t (arc-length-uniform)
 *   - setProgress(n) — StreetcarRig writes this every frame
 *   - onEndOfLine() / onArrivalDone() — reserved callbacks (no-op in v1)
 */
interface StreetcarStore {
  progress: number;
  setProgress: (n: number) => void;
  onEndOfLine: () => void;
  onArrivalDone: () => void;
}

export const useStreetcarStore = create<StreetcarStore>((set) => ({
  progress: 0,
  setProgress: (progress) => set({ progress }),
  onEndOfLine: () => {
    /* no-op; real dispatch fires via useNavSend in StreetcarRig */
  },
  onArrivalDone: () => {
    /* no-op; real dispatch fires via useNavSend in ArrivalCinematic */
  },
}));
